var PageEntryPoint =
webpackJsonpPageEntryPoint([6,12],{

/***/ "+No7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by c_razmuss_a on 12/10/2017.
 */


var $ = __webpack_require__("7t+N");
__webpack_require__("gNGx");
var positioning = __webpack_require__("KFdh");
var header = __webpack_require__("iPHx");
var footer = __webpack_require__("rqn6");
var internationalSchemeService = __webpack_require__("lQbp");
var loginStatusService = __webpack_require__("Ytzv");
var i18n = __webpack_require__("IlWE");

function init(isLoginLogoutCta) {
    positioning.sameHeightConfig.minWidth = 0;
    positioning.registerSameHeightListener();

    var logonPromise = $.when(i18n.init(), loginStatusService.getIsUserLoggedIn())
        .done(function (i18n, isLoggedIn) {
            var headerCb = (isLoginLogoutCta === true) ? header.initWithLoginCta : header.init;
            headerCb(isLoggedIn, false);
        });

    var contactInfoPromise = internationalSchemeService.getContactInformation();
    contactInfoPromise.done(footer.init);

    return $.when(contactInfoPromise, logonPromise);
}

module.exports.init = init;


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0v5J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function formPush(event, formType, formStep, stepType) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formItemPush(event, formType, formStep, stepType, itemName) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formPeoplePush(event, formType, formStep, stepType, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            peopleCovered : peopleCovered,
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formPlansPush(event, formType, formStep, stepType, numberPlans) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            numberPlans : numberPlans,
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function quoteCompletePush(event, formType, formStep, peopleCovered, member, stepType) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            peopleCovered : peopleCovered,
            member : member,
            stepType : stepType
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function healthPMIQuoteCompletePush(event, formType, formStep, stepType, itemName, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            peopleCovered : peopleCovered
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function memberItemPush(event, formType, formStep, stepType, itemName, member) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            member : member
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function ecommercePush(event, formType, formStep, stepType, peopleCovered, itemCategory, ecommerce) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            peopleCovered : peopleCovered,
            itemCategory : itemCategory,
            ecommerce : ecommerce
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function internationalDestinationPush(event, formType, formStep, stepType, itemName, destination) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            destination : destination
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function formAddOnsPush(event, formType, formStep, stepType, addOns) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            addOn : addOns
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

function intReviewPush(event, formType, formStep, stepType, itemName, addOns, peopleCovered) {
    try {
        var dataLayer = window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : event,
            formType : formType,
            formStep : formStep,
            stepType : stepType,
            itemName : itemName,
            addOn : addOns,
            peopleCovered : peopleCovered
        });
    } catch (exception) {
        console.log('formSubmissionSuccess dataLayer.push failed');
        return true;
    }
}

module.exports = {
    formPush: formPush,
    formItemPush: formItemPush,
    formPeoplePush : formPeoplePush,
    formPlansPush : formPlansPush,
    quoteCompletePush: quoteCompletePush,
    healthPMIQuoteCompletePush: healthPMIQuoteCompletePush,
    memberItemPush: memberItemPush,
    ecommercePush: ecommercePush,
    internationalDestinationPush: internationalDestinationPush,
    formAddOnsPush: formAddOnsPush,
    intReviewPush: intReviewPush
};

/***/ }),

/***/ "2NfQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * To mimic enum com.vhi.group.web.transactions.TransactionStage from backend
 * Created by c_razmuss_a on 30/01/2018.
 */
//const
var transactionStage = ['INIT', 'POLICY', 'PEOPLE', 'DETAILS', 'COVER', 'ADDONS', 'PLAN', 'CHECKOUT', 'PREFERENCES', 'REVIEW', 'COMPLETED'];

function createStageObject() {
    var result = {};
    transactionStage.forEach(function (stage) {
       result[stage] = stage;
    });
    result.indexOf = function(s, i) {
        return transactionStage.indexOf(s, i);
    };
    return result;
}

module.exports = createStageObject();


/***/ }),

/***/ "7Iys":
/***/ (function(module, exports, __webpack_require__) {

var jade = __webpack_require__("TBTh");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (isLoggedIn) {
var linkId = (isLoggedIn === true) ? 'navbar-logout-link' : 'navbar-login-link'
var linkClass = (isLoggedIn === true) ? 'webchat-myvhi-logout' : 'webchat-myvhi-login'
var btnText = (isLoggedIn === true) ? 'common:header.logout' : 'common:header.login'
var url =  (isLoggedIn === true) ? "javascript:window.location.href='logout';" : '/myvhi'
buf.push("<a" + (jade.attr("id", '' + (linkId) + '', true, true)) + (jade.attr("href", '' + (url) + '', true, true)) + (jade.cls(['navbar-login-link ' + (linkClass) + ''], [true])) + "><button id=\"navbar-login-btn\"" + (jade.attr("data-i18n", "" + (btnText) + "", true, true)) + " class=\"navbar-login-btn\">Log out</button></a>");}.call(this,"isLoggedIn" in locals_for_with?locals_for_with.isLoggedIn:typeof isLoggedIn!=="undefined"?isLoggedIn:undefined));;return buf.join("");
}

/***/ }),

/***/ "CCE4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var urls = __webpack_require__("g+w9");

var ajaxStatusConfig = {
    STATUS_GONE: 410,
    UNPROCESSABLE: 422,
	NOT_IMPLEMENTED: 501
};

function ajaxGetJson(config){
	return $.ajax({
					url : config.url,
					dataType: 'json',
					contentType: 'application/json; charset=utf-8',
					headers: config.headers,
					data: getJsonString(config),
					async	: getAsync(config),
					type : 'GET'
			});
}

function ajaxPostJson(config) {
	return $.ajax({
		url : config.url,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8',
		headers: getHeaders(config),
		data: getJsonString(config),
		async	: getAsync(config),
		type : 'POST',
		timeout: config.timeout
	});
}

function getJsonString(config){
	return (typeof config.jsonString !== 'undefined') ? config.jsonString : '';
}

function getAsync(config) {
	if (typeof config.async === 'undefined') {
		return true;
	} else {
		return config.async;
	}
}

function getHeaders(config){
	return (typeof config.headers !== 'undefined') ? config.headers : '';
}

/**
 * Helper method to be used in .fail() handler of jquery AJAX requests
 * Provides generic failure handling and ability to ignore certain codes
 * @param message
 * @param ignoreCodes - optional array of numbers for status codes for which error handling won't be invoked
 * @returns {Function}
 */
function handleError(message, ignoreCodes) {
    return function (jqXHR, status, faf) {
        if (ignoreCodes && ignoreCodes.indexOf(jqXHR.status) > -1) {
            console.log('Skipping processing of error code ' + jqXHR.status);
        } else {
            errorHandler(jqXHR, message);
        }
    };
}

/**
 * Jquery ajax error handler
 */
function errorHandler(jqXHR, message) {
    console.error('ajaxHandler.errorHandler '+jqXHR.status+' '+ message);
    if (jqXHR.status === ajaxStatusConfig.UNPROCESSABLE) {
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.STATUS_GONE) {
        urls.navigateToUrl("/intgroups"+'/session-expired');
        return;
    }

    if (jqXHR.status === ajaxStatusConfig.NOT_IMPLEMENTED) {
        urls.navigateToUrl("/intgroups"+'/not-supported');
        return;
    }
	urls.navigateToUrl("/intgroups"+'/internal-problem');

}

module.exports = {
	ajaxGetJson : ajaxGetJson,
	ajaxPostJson: ajaxPostJson,
    handleError: handleError,
	errorHandler: errorHandler,
};



/***/ }),

/***/ "Dh8f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var urls = __webpack_require__("g+w9");
var transactionStage = __webpack_require__("2NfQ");

function renderSecondaryBreadCrumbs() {
    var $breadcrumbSecondary_element = $('.breadcrumb-secondary .element');
    if($breadcrumbSecondary_element.length === 2) {
        $('.breadcrumb-secondary').css('width', '212px');
    }

    var hasCurrent = $('.breadcrumb-secondary .element.current').length > 0;
    var prev = null;
    $breadcrumbSecondary_element.each(function(){
        if(prev !== null) {
            var currentPos = $(this).offset().left + $(this).width()/2;
            var prevPos = prev.offset().left + prev.width()/2;
            var width = currentPos - prevPos;
            $(this).find('.line').css({'width': width, 'right': $(this).width()/2});
        }
        prev = $(this);

        if(hasCurrent) {
            $(this).addClass('active');
        }

        if($(this).hasClass('current')) {
            hasCurrent = false;
        }
    });
}

function init(props) {
    renderSecondaryBreadCrumbs();
    $(window).resize(function(){
        renderSecondaryBreadCrumbs();
    });
    initOnDataChange();

    setAccessibleByTransactionStage(props.sessionTransactionStage);

}

function setAccessibleByTransactionStage(stage) {

    var index = transactionStage.indexOf(stage);

    function render(element) {
        var elementId = element.attr('data-id');
        var elementIndex = transactionStage.indexOf(elementId);
        
        if(elementIndex > index) {
            return false;
        }

        element.addClass('navi');            
        if(stage === elementId) {
            return false;
        }

        return true;
    }

    // Set accessible primary breadcrumb
    $('.breadcrumb-primary .element').each(function(){
        if(!render($(this))) { 
            return false;
        }
    });
    // Set accessible secondary breadcrumb
    $('.breadcrumb-secondary .element').each(function(){
        if(!render($(this))) { 
            return false;
        }
    });
}

$('.breadcrumb-primary .element a, .breadcrumb-secondary .element a').click(function(e){
    e.preventDefault();
    //Prevent users to be able to navigate to link if not allowed
    var parent = $(this).parent('.element');
    if((!parent.hasClass('active') && !parent.hasClass('navi')) || parent.hasClass('current')) {
        return false;
    }

    //Append parameters if present
    var href = $(this).attr('href');

    if(urls.getAllUrlParameters()) {
        if(href.indexOf('?') !== -1) {
            href += '&';
        } else {
            href += '?';
        }
        href += urls.getAllUrlParameters();
    }
    urls.navigateToUrl(href);
    
});

function initOnDataChange() {
    $('.journey-container')
        .on('input', 'input', clearForwardLinks)
        .on('change', 'select', clearForwardLinks)
        .on('click', 'input[type="radio"]', clearForwardLinks)
        .on('click', 'input[type="checkbox"]', clearForwardLinks)
        .on('change', '.datepicker', clearForwardLinks);

    $('body').on('click', '.carousel .add-people-checkbox', clearForwardLinks);
}

function clearForwardLinks() {

    //attribute will be used to indicate that user has made a data change on the form.
    //Will be used to decide whether to POST or forward to next page in scenario
    //where they have navigated backwards in the journey
    $('.journey-container').attr('data-changed', true);

    var primaryNav = true;
    $('.breadcrumb-primary .element').each(function(){
        if(primaryNav && $(this).hasClass('current')) {
            primaryNav = false;
        } else if(!primaryNav) {
            $(this).removeClass('navi');
        }
    });

    var secondaryNav = true;
    $('.breadcrumb-secondary .element').each(function(){
        if(secondaryNav && $(this).hasClass('current')) {
            secondaryNav = false;
        } else if(!secondaryNav) {
            $(this).removeClass('navi');
        }
    });
}

module.exports = {
    init: init,
    clearForwardLinks: clearForwardLinks,
    setAccessibleByTransactionStage: setAccessibleByTransactionStage,
};


/***/ }),

/***/ "IlWE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var i18n = __webpack_require__("lwx0");

var options = {
    ns: ['intl', 'common'],
    defaultNS: 'intl',
    backend: {
        loadPath: "/intgroups" + '/locales/{{lng}}/{{ns}}.json'
    },
};

var initialized;

function init() {
    if (initialized === undefined) {
        initialized = i18n.doSetup(options);
    }
    return initialized;
}

module.exports = {
    init: init,
    translate: i18n.translate
};


/***/ }),

/***/ "KVib":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var store = __webpack_require__("juAn");

var cacheKey = 'intlSessionTransactionStage';

function setTransactionStage(transactionStage) {
    store.session(cacheKey, transactionStage);
}

function getTransactionStage() {
    if (store.session.has(cacheKey)) {
        return store.session.get(cacheKey);
    }
    else {
        return 'INIT';
    }
}

module.exports = {
    setTransactionStage : setTransactionStage,
    getTransactionStage: getTransactionStage
};

/***/ }),

/***/ "NvBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var disablingLayer = __webpack_require__("OBNk");
var intlPageSetup = __webpack_require__("+No7");
var addonsService = __webpack_require__("OmGD");
var addonsBoxJade = __webpack_require__("8Nyp");
var urls = __webpack_require__("g+w9");

var transactionStageService = __webpack_require__("KVib");
var breadCrumb = __webpack_require__("Dh8f");
var thisPageAnalytics = __webpack_require__("UG47");

var transactionId;

function init() {

    transactionId = urls.getUrlParameter("transaction-id");
    var nextPageUrl = '/intgroups/join-preferences?transaction-id=' + transactionId;
    var transactionStage = transactionStageService.getTransactionStage();

    return $.when(intlPageSetup.init(), addonsService.getAvailableAddonsList(transactionId), addonsService.getAddonsList(transactionId))
        .then(function (setup, availableAddons, selectedAddons) {
            $('#addonsBox').html(addonsBoxJade({ addons: availableAddons }));

            $('.addon-container').localize();
            $('.journey-content').localize();
            $('.addon-footer').localize();

            checkAddonCheckboxes(selectedAddons);
            initListeners();

            disablingLayer.hideDisablingLayer();
            initBreadCrumb();

        });
    
    function initListeners() {
        var btnNext = $('#next');

        if (pageHasCheckedCheckboxes()) {
            btnNext.prop('disabled', false);
        } else {
            btnNext.prop('disabled', true);
        }

        btnNext.on('click', onNextClick);
        $('#thanks').on('click', onThanksClick);

        $('.checkbox').change(function () {
            if(this.checked) {
                btnNext.prop('disabled', false);
            }
            else if(!pageHasCheckedCheckboxes()) {
                btnNext.prop('disabled', true);
            }
        });

        thisPageAnalytics.addAnalyticsHandlers();
    }

    function pageHasCheckedCheckboxes() {
        var result = false;
        $(".checkbox").each(function () {
            if($(this).prop('checked') === true) {
                result = true;

            }
        });
        return result;
    }

    function checkAddonCheckboxes(addons) {
        $(".checkbox").each(function () {
            for (var i = 0; i < addons.length; i++) {
                if ($(this).val() === addons[i].code) {
                    $(this).prop('checked', true);
                }
            }
        });
    }


    function initBreadCrumb() {
        breadCrumb.init({
            sessionTransactionStage: transactionStage
        });
    }
    
    function onNextClick(event) {
        event.preventDefault();

        var addons = [];
        $(".checkbox:checked").each(function () {
            addons.push({ code: $(this).val() });
        });

        postAddons(addons);
    }
    
    function onThanksClick(event) {
        event.preventDefault();

        postAddons([]);
    }

    function postAddons(addons) {
        addonsService.postAddonsList(addons, transactionId)
            .done(function () {
                transactionStageService.setTransactionStage("PREFERENCES");
                urls.navigateToUrl(nextPageUrl);
            })
            .fail("unable to post selected addons list");
    }
}

module.exports.init = init;


/***/ }),

/***/ "OmGD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ajaxHandler = __webpack_require__("CCE4");

function getAvailableAddonsList(transactionId) {
    var request = {
        url: "/intgroups" + '/rest/transactions/' + transactionId + '/addons/all'
    };
    return ajaxHandler
        .ajaxGetJson(request)
        .then(function (availableAddons) {
            return availableAddons;
        })
        .fail(ajaxHandler.handleError('unable to get available addons'));
}

function getAddonsList(transactionId) {
    var request = {
        url: "/intgroups" + '/rest/transactions/' + transactionId + '/addons'
    };
    return ajaxHandler
        .ajaxGetJson(request)
        .then(function (addons) {
            return addons;
        })
        .fail(ajaxHandler.handleError('unable to get addons'));
}

function postAddonsList(model, transactionId) {
    var request = {
        url: "/intgroups" + '/rest/transactions/' + transactionId + '/addons',
        jsonString: JSON.stringify(model)
    };
    return ajaxHandler.ajaxPostJson(request)
        .fail(ajaxHandler.handleError('unable to post addons list : ' + request.jsonString));
}

module.exports  = {
    getAvailableAddonsList: getAvailableAddonsList,
    getAddonsList: getAddonsList,
    postAddonsList: postAddonsList
};

/***/ }),

/***/ "TNSw":
/***/ (function(module, exports, __webpack_require__) {

var events = __webpack_require__("yq58");

var Parameters = {
    EVENT: 'event',
    FORMTYPE: 'formType',
    FORMSTEP: 'formStep',
    STEPTYPE: 'stepType',
    MEMBER: 'member',
    ECOMMERCE: 'ecommerce',
    VALUE: 'value',
    ITEMNAME: 'itemName',
    ITEMTYPE: 'itemType',
    MARKETING_PREFERENCES: 'marketing_preferences',
    DOCUMENT_PREFERENCES: 'document_preferences',
    PEOPLE_COVERED: 'peopleCovered',
    TRANSACTION_ID: 'transaction_id',
    FACILITY: 'hospital',
    TREATMENT_TYPE: 'treatmentType',
    DESTINATION: 'destination',
    ADDON: 'addOn'
};

var Items = {

    PMI_CODE: 'PMI0811',
    DENTAL_PLUS: 'dental_plus',
    DENTAL_STANDARD: 'dental'

};

var GLOBAL_CONFIG = {
    Debug: true,
    GA: {
        STAGING: 'XYZ',
        PRODUCTION: 'ABC',
    },
    GTM: {
        STAGING: 'XYZ',
        PRODUCTION: 'ABC',
    },
    Parameters : Parameters,
    Items: Items,
    Journeys : {
        GROUP_TRANSFER: 'group_transfer',
        GROUP_JOIN: 'group_join',
        INT_GROUP_JOIN: 'int_group_join'
    },
    Forms:{
        Events: {
            FormEvents : events.FormEvents,
            FormStepTypes: events.FormStepTypes
        }
    }
};

module.exports = {
    GLOBAL_CONFIG : GLOBAL_CONFIG,
};

/***/ }),

/***/ "UG47":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var analyticsUtil = __webpack_require__("0v5J");
var config = __webpack_require__("TNSw");

var formStepCompleteName = config.GLOBAL_CONFIG.Forms.Events.FormEvents.FORM_STEP_COMPLETE;
var intGroupJoinName = config.GLOBAL_CONFIG.Journeys.INT_GROUP_JOIN;
var addOnsName = config.GLOBAL_CONFIG.Forms.Events.FormStepTypes.ADD_ONS;

var addOns = [];

function addAnalyticsHandlers() {

    $('#thanks').click(function () {

        analyticsUtil.formPush(formStepCompleteName, intGroupJoinName, 4, addOnsName);

    });

    $('#next').click(function () {

        $(".checkbox").each(function () {
            if($(this).prop('checked') === true) {
                addOns.push( $(this).attr('value') );
            }
        });

        analyticsUtil.formAddOnsPush(formStepCompleteName, intGroupJoinName, 4, addOnsName, addOns);

    });

}

module.exports.addAnalyticsHandlers = addAnalyticsHandlers;

/***/ }),

/***/ "Ytzv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");

function getIsUserLoggedIn(){
    var userLoggedInPromise = $.Deferred();
    $.get( "/intgroups" + '/rest/accessManagement/loginStatus')
        .done(function (data) {
                console.log("getIsUserLoggedIn : " + data);
                if(data.loggedIn===true){
                    userLoggedInPromise.resolve(true);
                }else{
                    userLoggedInPromise.resolve(false);
                }
        })
        .fail(function(jqXHR, textStatus, error) {
            console.log( "error: status = %s", jqXHR.status);
            console.log( "error: responseText = %s", jqXHR.responseText);
            console.log( "error: textStatus = %s", textStatus);
            console.log( "error: error = %s", error);
            userLoggedInPromise.resolve(false);
        });

    return userLoggedInPromise.promise();
}

module.exports.getIsUserLoggedIn = getIsUserLoggedIn;

/***/ }),

/***/ "g+w9":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    'use strict';

    var testUrlParameters;

    function getAllUrlParameters() {
        if (testUrlParameters) {
            return testUrlParameters;
        }
        return window.location.search.substring(1);
    }

    function getUrlPath() {
        return window.location.pathname;
    }

    function redirectToUrl(destinationUrl) {
        window.location.replace(destinationUrl);
    }

    function navigateToUrl(destinationUrl) {
        window.location.href = destinationUrl;
    }

    return {
        getUrlParameter: function (paramName) {
            var params = getAllUrlParameters();
            console.log(params);
            var paramList = params.split('&');

            for (var i = 0; i < paramList.length; i++) {
                var param = paramList[i].split('=');
                if (param[0] === paramName) {
                    return param[1];
                }
            }
        },
        getAllUrlParameters: getAllUrlParameters,
        setTestUrlParameters: function (urlParameters) {
            testUrlParameters = urlParameters;
        },
        redirectToUrl: redirectToUrl,
        navigateToUrl: navigateToUrl,
        getUrlPath: getUrlPath
    };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "iPHx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var stickyHeader = __webpack_require__("j7WF");

/**
 * Initialises the header state.
 * <p>
 * Takes a promise as argument that return true/false.
 * If the promise resolves to true, the log out CTA is displayed.
 * For all other resolution states the log out CTA in NOT displayed.
 * </p>
 */
function init(isLoggedIn) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);
    showHideLogoutCTA(isLoggedIn);
}

function initWithLoginCta(isLoggedIn, isGroups) {
    stickyHeader.apply('nav-bar-top', 'page-container', false);

    if (isGroups || (!isGroups && isLoggedIn)) {
        var loginButtonTemplate = __webpack_require__("7Iys");
        var html = loginButtonTemplate({isLoggedIn: isLoggedIn});
        var $placeHolder = $('#login-btn-dynamic-content');
        $placeHolder.html(html);
    }
}

/**
 * Displays or hides the Logout CTA.
 * @param aBoolean if true the Logout CTA is displayed, remains hidden otherwise.
 */
function showHideLogoutCTA(aBoolean){
    if(aBoolean===true){
        $('#nav-logout').show();
    }else{
        $('#nav-logout').hide();
    }
}

module.exports = {
    init: init,
    initWithLoginCta: initWithLoginCta
};

/***/ }),

/***/ "juAn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//uses 'international' namespace to avoid conflicts with other apps
module.exports = __webpack_require__("Eb2/").namespace('international');

/***/ }),

/***/ "lQbp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("7t+N");
var ajaxHandler = __webpack_require__("CCE4");
var store = __webpack_require__("juAn");

//const
var cacheKey = 'intlGroupSchemeBasicInfo';
/**
 * as the group scheme data are related to session there is no need to have multiple concurrent requests
 */
var fetchInProgress;

function getSchemeInfo(refresh, groupSchemeToken) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey)).promise();
    } else {
        return fetchGroupScheme(groupSchemeToken);
    }
}

function getContactInformation(refresh) {
    if (refresh !== true && store.session.has(cacheKey)) {
        return $.Deferred().resolve(store.session.get(cacheKey).vhiContacts[0]).promise();
    } else {
        return fetchGroupScheme()
            .then(function(groupSchemeBasicInfo) {
                return groupSchemeBasicInfo.vhiContacts[0];
            });
    }
}

function fetchGroupScheme(groupSchemeToken) {
    if (fetchInProgress) {
        return fetchInProgress;
    } else {
        if (groupSchemeToken) {
            fetchInProgress = ajaxHandler.ajaxGetJson({url: "/intgroups" + '/rest/schemeByToken', jsonString: {'token': groupSchemeToken} })
                .then(function (groupSchemeBasicInfo) {
                    store.session(cacheKey, groupSchemeBasicInfo);
                    return groupSchemeBasicInfo;
                })
                .always(function () {
                    fetchInProgress = null;
                });
        } else {
            fetchInProgress = ajaxHandler.ajaxGetJson({ url: "/intgroups" + '/rest/scheme'})
                .then(function (groupSchemeBasicInfo) {
                    store.session(cacheKey, groupSchemeBasicInfo);
                    return groupSchemeBasicInfo;
                })
                .always(function () {
                    fetchInProgress = null;
                });
        }
        return fetchInProgress;
    }
}
module.exports.getSchemeInfo = getSchemeInfo;
module.exports.getContactInformation = getContactInformation;

/***/ }),

/***/ "lwx0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__("7t+N");
var jqueryI18next = __webpack_require__("+ZPT");
var i18next = __webpack_require__("QCdE");
var backend = __webpack_require__("OcWW");
var cache = __webpack_require__("IdM4");

var defaultOptions = {
    //debug: true,
    lng: 'en',
    fallbackLng: 'en',
    //ns: [],
    interpolation: {'escapeValue': false},
    backend: {
        loadPath: function(lng, ns){
            if(ns.indexOf('plan-names') !== -1){
                return '/online-services/plan-names';
            }else{
                return '/groups/' + 'locales/' + lng + '/' + ns + '.json';
            }
        }
    },
    cache:
        {
            enabled: true,
            // prefix for stored languages
            prefix: 'i18next_res_',
            // expiration (10 mins)
            expirationTime: 10 * 60 * 1000
        }
};

function doSetup(options) {
    var mergedOpts = $.extend({}, defaultOptions, options);

    jqueryI18next.init(i18next, $);

    var deferred = $.Deferred();

    i18next.use(backend)
        .use(cache)
        .init(mergedOpts, function(err, t) {
            if (err) {
                console.error(err);//all bad failed to initialize
            } else {
                deferred.resolve(i18next); //now we can translate
            }
        });

    return deferred.promise();
}

/**
 * Returns a function to be used for jquery validator.
 * Validator doesn't support promises, thus we expect i18n has already been initialized
 * if you need regular translations in javascript better use i18next resolved value from i18n.init() promise
 * @param key
 * @returns {Function}
 */
function translate(key) {
    return function() {
        return i18next.t(key);
    };
}

module.exports = {
    doSetup: doSetup,
    translate: translate
};



/***/ }),

/***/ "yq58":
/***/ (function(module, exports) {

var FormEvents = {
    FORM_START: 'form_start',
    QUOTE_COMPLETE: 'quote_complete',
    FORM_STEP_BACK: 'form_step_back',
    EMAIL_QUOTE: 'email_quote',
    FORM_STEP_COMPLETE: 'form_step_complete',
    PURCHASE: 'purchase',
    FULL_QUOTE_COMPLETE: 'full_quote_complete',
    NUMBER_PLANS_RETURNED: 'number_plans_returned',
    SNAP_AND_SEND_SUBMIT: 'snap_send_submit',
};

var FormStepTypes = {
    START: 'start',
    COMPLETE: 'complete',
    GET_QUOTE: 'get_quote',
    QUOTE_REVIEW: 'quote_review',
    GET_FULL_QUOTE: 'get_full_quote',
    FULL_QUOTE_REVIEW: 'full_quote_review',
    PREFERENCES: 'preferences',
    PEOPLE: 'people',
    DETAILS: 'details',
    CHECKOUT: 'checkout',
    CLAIM_SEND: 'claim_send',
    ADD_ONS: 'add_ons',
    SUBMIT: 'submit'
};

module.exports = {
    FormEvents: FormEvents,
    FormStepTypes: FormStepTypes,
};

/***/ })

},["NvBc"]);


// WEBPACK FOOTER //
// /join-plan-addons.js